
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/donation",
      function () {
        return require("private-next-pages/[region]/[language]/donation/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/donation"])
      });
    }
  